import s from './add-card-fail.module.scss'
import { motion } from 'framer-motion';
import { useState } from 'react';
import classNames from 'classnames';
import { Button } from '@shared/ui/button/button';
import { IconChevronRight, IconCircleXFilled } from '@tabler/icons-react';
import { getCDNPath } from '@utils/lib/getCDNpath';

export const AddCardFail = () => {
	const [isMascotLoaded, setIsMascotLoaded] = useState(false)

	return (
		<motion.div
			className={s.wrapper}
			initial={{ opacity: 0, y: 16 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
		>
			<div className={s.card}>
				<div className={s.header}>
					<div className={s.headerContent}>
						<motion.span
							className={s.badge}
							initial={{ scale: 0 }}
							animate={{ scale: 1 }}
							transition={{ type: 'spring', stiffness: 260, damping: 18, delay: 0.1 }}
						>
							<IconCircleXFilled size={36} className={s.badgeIcon}/>
						</motion.span>
						<h2 className={s.title}>Карту не удалось привязать</h2>
						<p className={s.subtitle}>Попробуйте привязать карту заново или обратитесь в поддержку.</p>
					</div>
					<img
						className={classNames(s.mascot, isMascotLoaded && s.mascotLoaded)}
						src={getCDNPath('images/mascot/sad.webp')}
						alt=""
						onLoad={() => setIsMascotLoaded(true)}
						onError={(e) => { e.target.style.display = 'none'; }}
					/>
				</div>

				<div className={s.buttons}>
					<Button theme='secondary' label='На главную' to={'/'} className={s.btn}/>
					<Button label='К настройкам' to={'/settings'} rightIcon={<IconChevronRight size={16}/>} className={s.btn}/>
				</div>
			</div>
		</motion.div>
	)
}
